require("core-js/modules/es.date.to-string.js");

var isSameMinute = require('../is_same_minute/index.js');
/**
 * @category Minute Helpers
 * @summary Is the given date in the same minute as the current date?
 *
 * @description
 * Is the given date in the same minute as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this minute
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:00 in this minute?
 * var result = isThisMinute(new Date(2014, 8, 25, 18, 30))
 * //=> true
 */


function isThisMinute(dirtyDate) {
  return isSameMinute(new Date(), dirtyDate);
}

module.exports = isThisMinute;